var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4847_10770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 2.16675C7.02008 2.16675 2.16675 7.02008 2.16675 13.0001C2.16675 18.9801 7.02008 23.8334 13.0001 23.8334C18.9801 23.8334 23.8334 18.9801 23.8334 13.0001C23.8334 7.02008 18.9801 2.16675 13.0001 2.16675ZM13.0001 5.41675C14.7984 5.41675 16.2501 6.86842 16.2501 8.66675C16.2501 10.4651 14.7984 11.9167 13.0001 11.9167C11.2017 11.9167 9.75008 10.4651 9.75008 8.66675C9.75008 6.86842 11.2017 5.41675 13.0001 5.41675ZM13.0001 20.8001C10.2917 20.8001 7.89758 19.4134 6.50008 17.3117C6.53258 15.1559 10.8334 13.9751 13.0001 13.9751C15.1559 13.9751 19.4676 15.1559 19.5001 17.3117C18.1026 19.4134 15.7084 20.8001 13.0001 20.8001Z",
    fill: "#5D2EFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4847_10770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account-circle.754a8c0808d1dc5869ccb585870b11e1.svg";
export { ForwardRef as ReactComponent };